import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import './App.css';

import { connect } from "react-redux";
import { getSchema } from "./actions";
import { getGymnasts } from "./actions";
import { setTeamFilter } from "./actions";
import { setYearFilter } from "./actions";
import { setGymnastFilter } from "./actions";

import Main from './components/Main';
import TeamRankings from './components/TeamRankings';
import TeamConsistency from './components/TeamConsistency';
import IndConsistency from './components/IndConsistency';
import MVP from './components/MVP';
import ImpactDiff from './components/ImpactDiff';
import TopScores from './components/TopScores';
import LineupFreq from './components/LineupFreq';
import Gymnast from './components/Gymnast';

import NavBoxes from './components/nav/NavBoxes';
import TeamSelect from './components/nav/TeamSelect';
import YearSelect from './components/nav/YearSelect';
import GymnastSelect from './components/nav/GymnastSelect';
//import Loader from './components/nav/Loader';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Router basename="/results/teamsGA">
          <div>
            <Route path='/:page?/:year?/:tid?/:gid?' render={(props) => (
              <div>
                <NavBoxes {...props} />
                  <div className="row expanded">
                    <div className="small-12 columns">
                    <TeamSelect teamFilter={this.props.teamFilter} gymnastFilter={this.props.gymnastFilter} teams={this.props.teams} yearFilter={this.props.yearFilter} handleTeamChange={this.handleTeamChange}{...props} />
                    <YearSelect teamFilter={this.props.teamFilter} yearFilter={this.props.yearFilter} gymnastFilter={this.props.gymnastFilter} years={this.props.years} handleYearChange={this.handleYearChange}{...props} />
                    <GymnastSelect teamFilter={this.props.teamFilter} yearFilter={this.props.yearFilter} gymnastFilter={this.props.gymnastFilter} gymnasts={this.props.gymnasts} handleGymnastChange={this.handleGymnastChange}{...props} />
                    </div>
                  </div>
              </div>
            )} />
              <div className="row expanded">
                <div className="small-12 columns small-collapse small-no-spacing">
                  <Route exact path='/' render={(props) => (
                    <Main teamFilter={this.props.teamFilter} yearFilter={this.props.yearFilter} {...props} />
                  )} />
                  <Route path='/dashboard/:year/:tid' render={(props) => (
                    <Main teamFilter={this.props.teamFilter} yearFilter={this.props.yearFilter} {...props} />
                  )} />
                 <Route path='/ch_team_rankings' render={(props) => (
                   <TeamRankings teamFilter={this.props.teamFilter} yearFilter={this.props.yearFilter} {...props} />
                 )} />
                 <Route path='/ch_consistency_t' render={(props) => (
                    <TeamConsistency {...props} />
                  )} />
                  <Route path='/ch_consistency_i' render={(props) => (
                    <IndConsistency teamFilter={this.props.teamFilter} yearFilter={this.props.yearFilter} gymnastFilter={this.props.gymnastFilter}{...props} />
                  )} />
                  <Route path='/ch_mvp' render={(props) => (
                    <MVP teamFilter={this.props.teamFilter} yearFilter={this.props.yearFilter} {...props} />
                  )} />
                  <Route path='/ch_impact_diff' render={(props) => (
                    <ImpactDiff teamFilter={this.props.teamFilter} yearFilter={this.props.yearFilter} meets={this.props.meets} {...props} />
                  )} />
                  <Route path='/ch_top_scores' render={(props) => (
                    <TopScores teamFilter={this.props.teamFilter} yearFilter={this.props.yearFilter} {...props} />
                  )} />
                 <Route path='/ch_lineup_freq' render={(props) => (
                   <LineupFreq teamFilter={this.props.teamFilter} yearFilter={this.props.yearFilter} {...props} />
                 )} />
                 <Route path='/gymnast/:year/:tid/:gid?' render={(props) => (
                   <Gymnast teamFilter={this.props.teamFilter} yearFilter={this.props.yearFilter} gymnastFilter={this.props.gymnastFilter} setGymnast={this.setGymnast} {...props} />
                 )} />
              </div>
            </div>
         </div>
        </Router>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    schema: state.main.schema,
    teamFilter: state.main.teamFilter,
    yearFilter: state.main.yearFilter,
    gymnasts: state.main.gymnasts,
    gymnastFilter: state.main.gymnastFilter,
    meets: state.main.meets,
    teams: state.main.teams,
    years: state.main.years
  };
}

export default connect(mapStateToProps, { getSchema, getGymnasts, setTeamFilter, setYearFilter, setGymnastFilter })(App);
